import { Token } from 'config/types'
import { ChainIdEnum } from '../network'

const path = '/images/token'

const tokens: Record<string, Token> = {
  S: {
    coinGeckoInfo: {
      id: 'sonic-3',
    },
    logo: `${path}/s.png`,
    name: 'S',
    code: 'S',
    network: ChainIdEnum.SONIC_TESTNET,
    decimals: 18,
    isNative: true,
  },
  USDC: {
    coinGeckoInfo: {
      id: 'usd-coin',
    },
    logo: `${path}/usdc.png`,
    name: 'USDC',
    code: 'USDC',
    network: ChainIdEnum.SONIC_TESTNET,
    address: '0x51f68CD4EBa5aFB92899871B0a46da51F9808b90',
    decimals: 6,
    isStable: true,
  },
}

export default tokens
